var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-list',{attrs:{"loading":_vm.loadingVal,"finished":_vm.finished,"offset":100,"loading-text":_vm.loadingText,"finished-text":_vm.finishedText,"error":_vm.errorits,"error-text":_vm.errorText},on:{"update:error":function($event){_vm.errorits=$event},"load":_vm.onLoad}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }